import React from 'react';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';

/**
 * MenuItem - Individual menu item component for the left panel
 * 
 * @param {Object} props - Component props
 * @param {Object} props.item - Menu item object containing name, icon, key, etc.
 * @param {boolean} props.isSelected - Whether this item is currently selected
 * @param {Function} props.onClick - Click handler for the menu item
 * @param {boolean} props.isDrawerExpanded - Whether the drawer is expanded
 * @param {boolean} props.isNewMessage - Whether there are new messages (for messaging item)
 * @param {boolean} props.isHovering - Whether the mouse is hovering over the drawer
 * @returns {JSX.Element} Rendered menu item
 */
const MenuItem = React.memo(
  ({
    item,
    isSelected,
    onClick,
    isDrawerExpanded,
    isNewMessage,
    isHovering,
  }) => (
    <ListItem
      disablePadding
      onClick={onClick}
      className={isSelected ? 'selected' : ''}
    >
      <ListItemButton>
        <Tooltip title={item.name} placement='right'>
          <ListItemIcon
            className={isSelected ? 'selectedIcon' : 'nonSelectedIcon'}
          >
            {item.icon}
          </ListItemIcon>
        </Tooltip>
        {(isDrawerExpanded || isHovering) && (
          <ListItemText
            className={isSelected ? 'selectedIcon' : 'nonSelectedIcon'}
            primary={item.name}
          />
        )}
        {item.key === 'Messaging' && item.additionalIcon && isNewMessage && (
          <ListItemIcon>
            <div style={{ fontSize: '1.5rem', color: 'green' }}>
              {item.additionalIcon}
            </div>
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  )
);

export default MenuItem; 